// extracted by mini-css-extract-plugin
export default {"label":"select_label__mXXX7","hidden":"select_hidden__OkQzr","dropdown":"select_dropdown__8LPps"};